import { Component, OnInit, ViewChild } from "@angular/core";
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import { GrupoPermissaoService } from "@core/services/grupo-permissao.service";
import Swal from "sweetalert2";
import { Subject } from "rxjs";
import { AuthenticationService } from "app/auth/service";
import { Router } from "@angular/router";

@Component({
	selector: "app-listar-grupo-permissao",
	templateUrl: "./listar-grupo-permissao.component.html",
	styleUrls: ["./listar-grupo-permissao.component.scss"],
})
export class ListarGrupoPermissaoComponent implements OnInit {
	// Private
	private _unsubscribeAll: Subject<any>;

	// public
	public contentHeader: object;
	public basicSelectedOption: number = 10;
	public ColumnMode = ColumnMode;

	//dados da tabela
	public rows = [];
	temp = [];

	constructor() {
		this._unsubscribeAll = new Subject();
	}

	@ViewChild(DatatableComponent) table: DatatableComponent;
	@ViewChild("tableRowDetails") tableRowDetails: any;
	ngOnInit(): void {
		// this.service.get().subscribe(
		//   (res) => {
		//     (this.rows = res), (this.temp = res);
		//   },
		//   (error) => error
		// );

		this.contentHeader = {
			headerTitle: "Grupo de Permissões",
			actionButton: false,
			breadcrumb: {
				type: "",
				links: [
					{
						name: "Início",
						isLink: false,
					},
					{
						name: "Grupo de permissão",
						isLink: false,
					},
				],
			},
		};
	}

	public msgConfirmacao(data) {
		Swal.fire({
			title: "Confirmação",
			text: "Deseja mesmo excluir?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Excluir",
			cancelButtonText: "Cancelar",
			customClass: {
				confirmButton: "btn btn-danger",
				cancelButton: "btn btn-primary ml-1",
			},
		}).then((result) => {
			if (result.isConfirmed) {
				// this.delete(data);
			}
		});
	}

	// public delete(id: number) {
	//   return this.service.delete(id).subscribe(
	//     (res) => {
	//       Swal.fire({
	//         title: "Sucesso!",
	//         text: "O item foi excluído.",
	//         icon: "success",
	//         confirmButtonText: "Confirmar",
	//       }).then((result) => {
	//         if (result.isConfirmed) {
	//           this.service.get().subscribe(
	//             (res) => (this.rows = res),
	//             (error) => error
	//           );
	//         }
	//       });
	//     },
	//     (error) => {
	//       Swal.fire("Erro!", "Ocorreu um erro ao cadastrar.", "error");
	//     }
	//   );
	// }

	grupoFilter(event) {
		const val = event.target.value.toLowerCase();

		// filter our data
		const temp = this.temp.filter(function (d) {
			return d.nome.toLowerCase().indexOf(val) !== -1 || !val;
		});

		// update the rows
		this.rows = temp;
		// Whenever the filter changes, always go back to the first page
		this.table.offset = 0;
	}
}
